import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { AutoSizer, List } from 'react-virtualized';
import Badge from '../../../components/bootstrap/Badge';
import Card, { CardBody, CardTabItem } from '../../../components/bootstrap/Card';
import OffCanvas, { OffCanvasBody, OffCanvasHeader, OffCanvasTitle } from '../../../components/bootstrap/OffCanvas';
import { getPersonDisplayName } from 'helpers/personNameI18n';

const AttendOffCanvas = ({ attendData, isAttendOffCanvas, setIsAttendOffCanvas }) => {
	const { t } = useTranslation();
	const tr = useCallback((name) => t(`userDashboard.${name}`), [t]);
	const type = [tr('attendance'), tr('absence'), t('approval.businessTrip'), t('approval.vacation')];
 
	return (
		<OffCanvas
			isBackdrop={true}
			isBodyScroll={true}
			placement={'end'}
			isOpen={isAttendOffCanvas}
			setOpen={setIsAttendOffCanvas}>
			<OffCanvasHeader setOpen={setIsAttendOffCanvas}>
				<OffCanvasTitle id='working'>{tr('currentStatus')}</OffCanvasTitle>
			</OffCanvasHeader>
			<OffCanvasBody className='p-0 '>
				<Card stretch hasTab shadow='none'>
					{/* type에 따른 근무 현황 OffCanvas 탭 */}
					{type.map((index, key) => {
						let data = [];
						switch (index) {
							case tr('attendance'):
								data = attendData?.attender || [];
								break;
							case tr('absence'):
								data = attendData?.attendNoter || [];
								break;
							case t('approval.businessTrip'):
								data = attendData?.outers || [];
								break;
							case t('approval.vacation'):
								data = attendData?.rester || [];
								break;
						}

						return (
							<CardTabItem
								id={index}
								key={index}
								title={
									<div className='position-relative'>
										{index}
										{data.length > 0 && (
											<Badge color='danger' className={'position-absolute top-0 start-100 translate-middle'}>
												{data.length}
											</Badge>
										)}
									</div>
								}>
								<CardBody className='h-100 p-0'>
									{data?.length <= 0 ? (
										<div className='text-center lead'>{t('userDashboard.thereNoRecords', { type: index })}</div>
									) : (
										<AutoSizer>
											{({ width, height }) => {
												return (
													<List
														width={width}
														height={height}
														rowCount={data.length}
														rowHeight={30}
														rowRenderer={({ index, key, style }) => {
															return (
																<div key={key} style={style} className={`${index % 2 == 0 && 'border-end'}`}>
																	<span className='lead'>{`${index + 1}. ${getPersonDisplayName(data[index]?.user) || '-'}`}</span>{' '}
																	{`${data[index]?.rank?.name || '-'} - ${
																		data[index]?.departments?.department?.name || ''
																	}`}
																</div>
															);
														}}
													/>
												);
											}}
										</AutoSizer>
									)}
								</CardBody>
							</CardTabItem>
						);
					})}
				</Card>
			</OffCanvasBody>
		</OffCanvas>
	);
};

export default memo(AttendOffCanvas);
